import { JSONSerializable } from '../../../util/json';
import { ParamChange, ParamChanges } from '../ParamChange';
export class ParameterChangeProposal extends JSONSerializable<
  ParameterChangeProposal.Data
> {
  changes: ParamChanges;

  constructor(
    public title: string,
    public description: string,
    changes: ParamChange.Data[] | ParamChanges
  ) {
    super();
    if (changes instanceof Array) {
      this.changes = ParamChanges.fromData(changes);
    } else {
      this.changes = changes;
    }
  }

  public static fromData(
    data: ParameterChangeProposal.Data
  ): ParameterChangeProposal {
    const {
      value: { title, description, changes },
    } = data;
    return new ParameterChangeProposal(
      title,
      description,
      ParamChanges.fromData(changes)
    );
  }

  public toData(): ParameterChangeProposal.Data {
    const { title, description, changes } = this;
    return {
      type: 'params/ParameterChangeProposal',
      value: {
        title,
        description,
        changes: ParamChanges.toData(changes),
      },
    };
  }
}

export namespace ParameterChangeProposal {
  export interface Data {
    type: 'params/ParameterChangeProposal';
    value: {
      title: string;
      description: string;
      changes: ParamChange.Data[];
    };
  }
}
